const RETURN_TO_KEY = "auth:returnTo";

// Routes that must never be used as a post-login destination
const AUTH_PATHS = ["/login", "/callback", "/verify-email"];

// Only allow internal, single-leading-slash paths to avoid open-redirects
// and prevent bouncing back into the auth flow itself.
const isSafeReturnTo = (path: string): boolean => {
  if (!path.startsWith("/")) return false;
  // Reject off-origin forms: "//evil.com" and "/\evil.com" (browsers normalize
  // the backslash to a slash, making it protocol-relative).
  if (path[1] === "/" || path[1] === "\\") return false;
  // Compare the pathname alone so query/hash variants (e.g. "/login#x") can't
  // slip past the auth-route check.
  const pathname = path.split(/[?#]/)[0];
  return !AUTH_PATHS.some((p) => pathname === p || pathname.startsWith(`${p}/`));
};

export const saveReturnTo = (path: string): void => {
  if (!isSafeReturnTo(path)) return;
  try {
    sessionStorage.setItem(RETURN_TO_KEY, path);
  } catch {
    // sessionStorage unavailable — deep-link restore is best-effort
  }
};

export const consumeReturnTo = (): string | null => {
  try {
    const path = sessionStorage.getItem(RETURN_TO_KEY);
    if (path) sessionStorage.removeItem(RETURN_TO_KEY);
    return path && isSafeReturnTo(path) ? path : null;
  } catch {
    return null;
  }
};
